module.exports = __webpack_public_path__ + "static/media/logo-natalino.21f0abb2.png";